import React from 'react';
import { PdfCanvasPlaceholder, PdfFramePlaceholder } from '../Shared/Pdf/PdfPlaceholders.tsx';

/**
 * What stands in for the chart preview while its chunk loads: the same markup
 * ChartPreview renders on its first frame, minus the PDF (ADR 0067).
 *
 * - Where the browser shows a PDF inline, the frame's page-shaped box.
 * - Where it does not - every phone - PdfActions' loading state: the canvas
 *   preview's box with the disabled "building" button under it.
 *
 * So the chunk arriving changes nothing on screen, and neither does the first
 * PDF. ChartPreview is the other copy of this shape; change both.
 */
export function ChartPreviewPlaceholder({
    canPreview,
    buildingLabel,
}: {
    canPreview: boolean;
    buildingLabel: string;
}) {
    if (!canPreview) {
        return (
            <div className="pdfActions">
                <PdfCanvasPlaceholder />
                <span className="pdfActionButton" aria-disabled="true">
                    {buildingLabel}
                </span>
            </div>
        );
    }
    return (
        <div className="pdfViewerContainer" role="status" aria-label={buildingLabel}>
            <PdfFramePlaceholder frameClassName="pdfViewerFrame" />
        </div>
    );
}

export default ChartPreviewPlaceholder;
